import { environment } from '../../../environments/environment';
import { TNC_JS_TEMPLATE } from './tnc-js-template';
import { RETAILOR_JS_TEMPLATE } from './retailor-js-template';

export function getJsClientTemplate(): string {
  return environment.jsClientTemplate === 'retailor'
    ? RETAILOR_JS_TEMPLATE
    : TNC_JS_TEMPLATE;
}

export function getJsClientTemplateName(): string {
  return environment.jsClientTemplate === 'retailor' ? 'retailor' : 'tnc';
}

export function getJsClientTemplateFor(template: 'tnc' | 'retailor'): string {
  return template === 'retailor' ? RETAILOR_JS_TEMPLATE : TNC_JS_TEMPLATE;
}

export function getJsClientTemplateNameFor(template: 'tnc' | 'retailor'): string {
  return template === 'retailor' ? 'retailor' : 'tnc';
}
